import { createAction, props } from '@ngrx/store';

import { TimelineListEntity } from '../components/timeline-list/timeline-list.entity';

export enum TimelineActions {
	InitTimelineList = '[Timeline] get timeline list',
	RefreshTimelineList = '[BE][Timeline] refresh timeline list',
	FetchTimelineListSuccess = '[BE][Timeline] fetch timeline list success',
	FetchTimelineListFail = '[BE][Timeline] fetch timeline list fail',
	NavigateToTimelineCreateRoute = '[Timeline] navigate to timeline create route',
	NavigateToTimelineRoute = '[Timeline] navigate to timeline route',
	ToggleTimelineStatus = '[Timeline] toggle timeline status',
	OpenDeleteConfirmationPopup = '[Timeline] open delete confirm popup',
	DeleteTimeline = '[Timeline] delete timeline',
	BulkDeleteTimelines = '[Timeline] delete many timelines',
	DeleteTimelineSuccess = '[BE][Timeline] delete timeline success',
	DeleteTimelineFail = '[BE][Timeline] delete timeline fail',
	DuplicateTimeline = '[Timeline] duplicate timeline',
	DuplicateTimelineSuccess = '[BE][Timeline] duplicate timeline success',
	DuplicateTimelineFail = '[BE][Timeline] duplicate timeline fail',
}

export const initTimelineList = createAction(TimelineActions.InitTimelineList);

export const refreshTimelineList = createAction(
	TimelineActions.RefreshTimelineList
);

export const fetchTimelineListSuccess = createAction(
	TimelineActions.FetchTimelineListSuccess,
	props<{ timelineList: TimelineListEntity }>()
);

export const fetchTimelineListFail = createAction(
	TimelineActions.FetchTimelineListFail,
	props<{ error: unknown }>()
);

export const navigateToTimelineCreate = createAction(
	TimelineActions.NavigateToTimelineCreateRoute
);

export const navigateToTimeline = createAction(
	TimelineActions.NavigateToTimelineRoute,
	props<{ id: number; goToVisuTab: boolean }>()
);

export const toggleTimelineStatus = createAction(
	TimelineActions.ToggleTimelineStatus,
	props<{ timelineId: number }>()
);

export const openDeleteConfirmationPopup = createAction(
	TimelineActions.OpenDeleteConfirmationPopup,
	props<{
		timelineId: Array<number>;
		timelineLabel: string;
	}>()
);

export const deleteTimeline = createAction(
	TimelineActions.DeleteTimeline,
	props<{ timelineId: number }>()
);

export const bulkDeleteTimelines = createAction(
	TimelineActions.BulkDeleteTimelines,
	props<{ timelineIds: Array<number> }>()
);

export const deleteTimelineSuccess = createAction(
	TimelineActions.DeleteTimelineSuccess
);

export const deleteTimelineFail = createAction(
	TimelineActions.DeleteTimelineFail,
	props<{ error: unknown }>()
);

export const duplicateTimeline = createAction(
	TimelineActions.DuplicateTimeline,
	props<{ timelineId: number }>()
);

export const duplicateTimelineSuccess = createAction(
	TimelineActions.DuplicateTimelineSuccess,
	props<{ id: number }>()
);

export const duplicateTimelineFail = createAction(
	TimelineActions.DuplicateTimelineFail,
	props<{ error: unknown }>()
);
